var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToTopBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xBA\xD0\xBD\xD0\xBE\xD0\xBF\xD0\xBA\xD0\xB0 \xD0\xB2\xD0\xB5\xD1\x80\xD1\x85"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 170",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "rotate(-90 20 20)",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 21",
    d: "M18.75 30C18.75 30.6904 19.3096 31.25 20 31.25C20.6904 31.25 21.25 30.6904 21.25 30H18.75ZM20.8839 9.11612C20.3957 8.62796 19.6043 8.62796 19.1161 9.11612L11.1612 17.0711C10.673 17.5592 10.673 18.3507 11.1612 18.8388C11.6493 19.327 12.4408 19.327 12.9289 18.8388L20 11.7678L27.0711 18.8388C27.5592 19.327 28.3507 19.327 28.8388 18.8388C29.327 18.3507 29.327 17.5592 28.8388 17.0711L20.8839 9.11612ZM21.25 30V10H18.75V30H21.25Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToTopBtn);
export default __webpack_public_path__ + "static/media/toTopBtn.14c22e9b9ecb6e75a00150b4f79258d2.svg";
export { ForwardRef as ReactComponent };